export const BREAK_POINT_XXS = '380px';
export const BREAK_POINT_CUSTOM_XS = '538px'; // custom break-point for flight search result collapse
export const BREAK_POINT_XS = '600px';
export const BREAK_POINT_SM = '768px';
export const BREAK_POINT_M = '900px';
export const BREAK_POINT_L = '1080px';
export const BREAK_POINT_XL = '1200px';
export const BREAK_POINT_XXL = '1400px';
